export default __webpack_public_path__ + "1aebf0c81b05082cfed4dd556cc6c285.svg";